import { ThemeMode } from '@modules/theme/constants';
import { useThemeStore } from '@modules/theme/store/useThemeStore';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AddToCollectionIcon = (props: SvgIconProps) => {
  const { mode } = useThemeStore();
  const isLightMode = mode === ThemeMode.LIGHT;

  const getColorFromProps = () => {
    if (!props.sx) {
      return;
    }
    if ('color' in props.sx) {
      return props.sx.color as string;
    }
  };

  const pathColor = getColorFromProps()
    ? 'currentColor'
    : isLightMode
    ? '#6738C3'
    : '#BFC2FF';

  const getLineColor = () => {
    if (getColorFromProps() === 'primary.contrastText') {
      return isLightMode ? '#6738C3' : '#BFC2FF';
    }

    return isLightMode ? '#FFFFFF' : '#23222E';
  };

  const lineColor = getLineColor();

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M5 20H17C17.55 20 18 20.45 18 21C18 21.55 17.55 22 17 22H4C2.9 22 2 21.1 2 20V7C2 6.45 2.45 6 3 6C3.55 6 4 6.45 4 7V19C4 19.55 4.45 20 5 20Z"
        fill={pathColor}
      />
      <path
        d="M8 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H8C6.9 18 6 17.1 6 16V4C6 2.9 6.9 2 8 2Z"
        fill={pathColor}
      />
      <path
        d="M19.1429 10.8571H14.8571V15.1429C14.8571 15.6143 14.4714 16 14 16C13.5286 16 13.1429 15.6143 13.1429 15.1429V10.8571H8.85714C8.38571 10.8571 8 10.4714 8 10C8 9.52857 8.38571 9.14286 8.85714 9.14286H13.1429V4.85714C13.1429 4.38571 13.5286 4 14 4C14.4714 4 14.8571 4.38571 14.8571 4.85714V9.14286H19.1429C19.6143 9.14286 20 9.52857 20 10C20 10.4714 19.6143 10.8571 19.1429 10.8571Z"
        fill={lineColor}
      />
    </SvgIcon>
  );
};
